import { WorkTypes } from './../enums/work-types';
export const LocationTypes = {
  REMOTE: 'Remote',
  ON_SITE: 'On-site'
}

export const LocationTypeLookup = [
  {
    id: WorkTypes.ON_SITE,
    value: LocationTypes.ON_SITE
  },
  {
    id: WorkTypes.REMOTE,
    value: LocationTypes.REMOTE
  },
  {
    id: -1,
    value: 'Any'
  },
]
